'use strict';

import agentModule from './module';

import './actions';
import './components';
import './layouts';
import './model';
import './services';

export default agentModule;
